import { render, staticRenderFns } from "./OrderSplitConfigManage.vue?vue&type=template&id=29499034&scoped=true"
import script from "./OrderSplitConfigManage.vue?vue&type=script&lang=js"
export * from "./OrderSplitConfigManage.vue?vue&type=script&lang=js"
import style0 from "./OrderSplitConfigManage.vue?vue&type=style&index=0&id=29499034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29499034",
  null
  
)

export default component.exports